import { FilterField } from '~/features/filter';

import { useCityOptions } from './useCityOptions';

type Translate = (key: string) => string;

export const ivideonDealerFilterFields = (t: Translate): FilterField[] => [
  {
    name: 'ids',
    type: 'input',
    label: t('dealers.id'),
  },
  {
    name: 'dealerName',
    type: 'input',
    label: t('dealers.DealerName'),
  },
  {
    name: 'address',
    type: 'input',
    label: t('ivideonCameras.tableDealers.address'),
  },
  {
    name: 'ivideonOwnerName',
    type: 'input',
    label: t('ivideonCameras.tableDealers.owner'),
  },
  {
    name: 'code',
    type: 'input',
    label: t('dealers.code'),
  },
  {
    name: 'category',
    type: 'input',
    label: t('ivideonCameras.tableDealers.category'),
  },
  {
    name: 'city',
    type: 'select',
    label: t('ivideonCameras.tableDealers.city'),
    optionsHook: useCityOptions,
  },
  {
    name: 'ivideonAuthorized',
    type: 'select',
    label: t('ivideonCameras.tableDealers.ivideonAuth'),
    options: [
      { label: 'Да', value: 'true' },
      { label: 'Нет', value: 'false' },
    ],
  },
  {
    name: 'serviceAccept',
    type: 'select',
    label: t('ivideonCameras.tableDealers.serviceCheck'),
    options: [
      { label: 'Проверен', value: 'true' },
      { label: 'Не проверен', value: 'false' },
    ],
  },
  {
    name: 'saleAccept',
    type: 'select',
    label: t('ivideonCameras.tableDealers.saleCheck'),
    options: [
      { label: 'Проверен', value: 'true' },
      { label: 'Не проверен', value: 'false' },
    ],
  },
  {
    name: 'checkStatus',
    type: 'select',
    label: t('ivideonCameras.tableDealers.checkStatus'),
    options: [
      { label: 'Проверен', value: 'true' },
      { label: 'Не проверен', value: 'false' },
    ],
  },
  {
    name: 'status',
    type: 'select',
    label: t('dealers.status') || 'Статус',
    options: [
      { label: 'Активный', value: 'active' },
      { label: 'Неактивный', value: 'inactive' },
    ],
  },
  {
    name: 'extendedForNextYear',
    type: 'select',
    label: t('dealers.extendedForNextYear') || 'Продлен на следующий год',
    options: [
      { label: 'Да', value: 'true' },
      { label: 'Нет', value: 'false' },
    ],
  },
];
